export default "__VITE_ASSET__BwsHCO8A__"